import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { ArrowLeft, Loader2 } from "lucide-react";
import { BrandLogo } from "../components/BrandLogo";
import { api } from "../lib/api";

export default function PolicyPage({ slug: slugProp }) {
  const params = useParams();
  const navigate = useNavigate();
  const slug = slugProp || params.slug;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/policies/${slug}`)
      .then((r) => { if (active) setData(r.data); })
      .catch(() => { if (active) setData(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [slug]);

  const updated = data?.updated_at ? new Date(data.updated_at).toLocaleDateString() : null;

  return (
    <div className="min-h-dvh">
      <header className="sticky top-0 z-40 border-b bg-[hsl(var(--background))]/85 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-2">
          <button onClick={() => navigate("/")} className="flex items-center gap-2" data-testid="policy-home"><BrandLogo size={30} withText /></button>
          <button onClick={() => navigate("/")} className="inline-flex items-center gap-1 text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]"><ArrowLeft className="h-4 w-4" /> Home</button>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10" data-testid="policy-page">
        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin" /></div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-semibold" style={{ color: "hsl(var(--brand-brown))" }} data-testid="policy-title">{data?.title || "Policy"}</h1>
            {updated && <p className="mt-1 text-xs text-[hsl(var(--muted-foreground))]">Last updated: {updated}</p>}
            <div className="prose-policy mt-6 text-sm leading-relaxed text-[hsl(var(--foreground))]" data-testid="policy-content">
              {data?.content ? (
                <ReactMarkdown>{data.content}</ReactMarkdown>
              ) : (
                <p className="text-[hsl(var(--muted-foreground))]">This policy will be published soon. Please check back later or contact us with any questions.</p>
              )}
            </div>
          </>
        )}
      </main>
    </div>
  );
}
